import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import ErrorHandler from "../../common/ErrorHandler";
import SubscriptionServices from "../../services/subscription/subscription.service";
import { errorToast, successToast } from "../../react-toastfiy/toast";
import UserIcon from "../../img/user-icon.png";

function ViewLogsModal(props) {
  const { user } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    try {
      setLoading(true);
      let form_data = new FormData();
      form_data.append("phone", user.user_phone);
      SubscriptionServices.GetUserLogsEntry(form_data).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          const renderedData = Object.entries(res.data).map(
            ([key, item], index) => ({
              msg: item?.msg ?? "",
              date: item?.date ?? "",
              time: item?.time ?? "",
              added_by: item?.added_by ?? "",
            })
          );
          if (renderedData.length !== 0) {
            setData(renderedData);
          }
        } else {
          errorToast(res?.msg);
        }
      });
    } catch (error) {
      console.log(error);
      errorToast(error.msg);
      setLoading(false);
    }
  }, []);

  try {
    return (
      <>
        <Modal
          {...props}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <div>
              <h5 className="m-0 p-0">{user.name} - Follow-Ups History</h5>
              {/* <p className="m-0 p-0" style={{ color: "grey" }}>
                Comunication history with {user.name}
              </p> */}
            </div>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "400px", overflow: "auto" }}>
            {loading ? (
              <div
                className="align-content-center text-center text-secondary"
                style={{ height: "100px" }}
              >
                Loading...
              </div>
            ) : (
              <>
                {data.length === 0 ? (
                  <div
                    className="align-content-center text-center"
                    style={{ height: "100px" }}
                  >
                    No Follow-Ups yet!
                  </div>
                ) : (
                  <>
                    {Object?.entries(data)?.map(([key, entry], index) => (
                      <div
                        className="border mb-3 p-2"
                        style={{ borderRadius: "4px" }}
                        key={index}
                      >
                        <div className=" d-flex justify-content-start align-items-start">
                          <img
                            src={UserIcon}
                            alt="user"
                            className="rounded-circle me-2"
                            style={{ width: "2rem", height: "auto" }}
                          />

                          <div className=" flex-grow-1">
                            <div className=" d-flex justify-content-between align-items-center mb-2">
                              <span className=" fs-6 me-2 flex-grow-1">
                                {entry?.added_by ? entry?.added_by : ""}
                              </span>

                              <div className="d-flex justify-content-start align-items-center text-secondary mb-1">
                                <i
                                  className="bi bi-calendar4 me-1"
                                  style={{ fontSize: "12px" }}
                                ></i>
                                <p
                                  className="m-0 p-0 me-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  {entry.date}
                                </p>
                                <i
                                  className="bi bi-clock me-1"
                                  style={{ fontSize: "12px" }}
                                ></i>
                                <p
                                  className="m-0 p-0 me-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  {entry.time}
                                </p>
                              </div>
                            </div>

                            <p
                              className="m-0 p-0 text-capitalize text-left"
                              style={{ fontSize: "14px" }}
                            >
                              {entry.msg}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </Modal.Body>
        </Modal>
      </>
    );
  } catch (error) {
    return <ErrorHandler error={error} />;
  }
}

export default ViewLogsModal;
